<div class="prompt-answer">
    <button class="input-button yes-btn" *ngIf="confirmButton != undefined"
        (click)="onButtonClicked(confirmButton)">{{confirmButton?.text}}</button>
    <button class="input-button no-btn" *ngIf="cancelButton != undefined"
        [class.disabled]="this.disable"
        [disabled]="this.disable"
        (click)="onButtonClicked(cancelButton)">{{cancelButton.text}}</button>
</div>
